<template>
  <div class="flex w-full flex-col gap-1">
    <label v-if="label" class="text-body-default w-full" :class="{ 'text-state-fgr-disabled': readonly }">
      {{ label }} <span v-if="isRequired" class="text-fgr-critical">*</span>
    </label>
    <div class="flex w-full gap-3">
      <Dropdown
        v-model="unit"
        class="min-w-[100px]"
        :options="options"
        :readonly
        :filterable="unitFilterable"
        @blur="emit('blur')"
      />
      <component
        :is="type === 'number' ? InputNumber : InputText"
        v-model="value"
        :class="valueClass"
        :step="step"
        :readonly
        class="w-full"
        @blur="emit('blur')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { InputNumber, InputText } from "#components";

  const {
    readonly = undefined,
    label = undefined,
    type = undefined,
    options,
    valueClass = undefined,
    step = undefined,
    unitFilterable = false,
    isRequired = false,
  } = defineProps<{
    readonly?: boolean;
    label?: string;
    type?: "text" | "number";
    options: { label: string; value: string }[];
    valueClass?: string;
    step?: number;
    unitFilterable?: boolean;
    isRequired?: boolean;
  }>();

  const unit = defineModel<string>("unit");
  const value = defineModel<number>("value");

  const emit = defineEmits<{
    (event: "blur"): void;
  }>();
</script>
